import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { FormField } from '../../../../../components/form/FormField';
import { fieldValidators } from '../../../../../helpers/fieldValidators';
import { Loader } from '../../../../../components/Loader';

let LegalFormsForm = props => {
  const { error, handleSubmit, submitting, currentItem } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="title"
        type="text"
        label="Название"
        validate={[fieldValidators.required]}
        component={FormField}
      />
      <Field
        name="short_title"
        type="text"
        label="Краткое название"
        validate={[fieldValidators.required]}
        component={FormField}
      />

      {error && <strong>{error}</strong>}
      <div>
        {submitting && <Loader />}
        <button type="submit" className="btn" disabled={submitting}>
          {currentItem ? 'Редактировать' : 'Создать'}
        </button>
      </div>
    </form>
  );
};

LegalFormsForm = reduxForm({
  form: 'legal-form', // a unique identifier for this form
  enableReinitialize: true
})(LegalFormsForm);

LegalFormsForm = connect(state => ({
  initialValues: {
    id: state.legalForms.currentItem ? state.legalForms.currentItem.id : '',
    title: state.legalForms.currentItem ? state.legalForms.currentItem.title : ''
  }
}))(LegalFormsForm);

export default LegalFormsForm;
